import { makeStyles } from '@material-ui/core/styles';

const useCheckoutStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  list: {
    width: '100%',
    backgroundColor: 'transparent',
    overflow: 'auto',
  },
  cost: {
    textAlign: 'right',
    fontWeight: 'bold',
  },
  mixins: {
    backgroundColor: '#2D3748',
    margin: '40px 0',
    paddingTop: '5px',
    borderRadius: '5px',
  },
}));

export default useCheckoutStyles;
